import ProductIcon from '@mui/icons-material/ShoppingBasket';

export default ProductIcon;
